import en from './en';
import fr from './fr';
import it from './it';
import es from './es';
import de from './de';
import ru from './ru';
import pt from './pt';
import nl from "./nl";
import pl from "./pl";

export default {
    'en-US': en,
    'fr-FR': fr,
    'it-IT': it,
    'es-ES': es,
    'de-DE': de,
    'ru-RU': ru,
    'pl-PL': pl,
    'pt-PT': pt,
    'nl-NL': nl,
};

export const languageLabels = {
    'en-US': 'ENGLISH',
    'de-DE': 'DEUTSCH',
    'es-ES': 'ESPAÑOL',
    'fr-FR': 'FRANÇAIS',
    'it-IT': 'ITALIANO',
    'nl-NL': 'NEDERLANDS',
    'pl-PL': 'POLSKI',
    'pt-PT': 'PORTUGUÊS',
    'ru-RU': 'PУССКИЙ',
};

export const languageMappings = {
    'en': 'en-US',
    'en-AU': 'en-US',
    'en-CA': 'en-US',
    'en-IN': 'en-US',
    'en-NZ': 'en-US',
    'en-ZA': 'en-US',
    'en-UK': 'en-US',

    'fr': 'fr-FR',
    'fr-CA': 'fr-FR',
    'fr-CH': 'fr-FR',

    'it': 'it-IT',
    'it-CH': 'it-IT',

    'es': 'es-ES',
    'es-AR': 'es-ES',
    'es-CL': 'es-ES',
    'es-CO': 'es-ES',
    'es-CR': 'es-ES',
    'es-HN': 'es-ES',
    'es-MX': 'es-ES',
    'es-PE': 'es-ES',
    'es-US': 'es-ES',
    'es-UY': 'es-ES',
    'es-VE': 'es-ES',
    'es-419': 'es-ES',

    'de': 'de-DE',
    'de-AT': 'de-DE',
    'de-CH': 'de-DE',
    'de-LI': 'de-DE',

    'ru': 'ru-RU',

    'pl': 'pl-PL',

    'pt': 'pt-PT',
    'pt-BR': 'pt-PT',

    'nl': 'nl-NL',
};